/**
 * URLs Storage : direct Supabase (dev) ou CDN Cloudflare (prod).
 * En prod, cdn.burok.app → cache long → moins d'egress Supabase.
 */
const SUPABASE_PROJECT_ID = 'xdmwmfswudrxvffzsaoe';

/** Origin direct Supabase (dev) */
const SUPABASE_STORAGE_URL = `https://${SUPABASE_PROJECT_ID}.supabase.co/storage/v1/object/public`;

/** CDN Cloudflare (prod) */
const CDN_STORAGE_URL = 'https://cdn.burok.app/storage/v1/object/public';

/** Base URL Storage : dev → Supabase, prod → CDN */
export const STORAGE_URL = import.meta.env.PROD ? CDN_STORAGE_URL : SUPABASE_STORAGE_URL;

/**
 * Assets statiques (logos, banners, icônes) → Cloudflare R2.
 * Domain custom: assets.burok.app
 */
export const ASSETS_URL = 'https://assets.burok.app';

/**
 * URL pour un asset statique hébergé sur R2 (logos, banners, images UI).
 * Ex: getAssetUrl('Files/Logos/Kiosk.gif') → https://assets.burok.app/Files/Logos/Kiosk.gif
 */
export const getAssetUrl = (path: string): string => {
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${ASSETS_URL}/${cleanPath}`;
};

/**
 * Construit une URL publique Storage (bucket + path).
 * Ex: getStorageUrl('myfiles', 'logos/BUROKLOGOTWITTER.png')
 */
export const getStorageUrl = (bucket: string, path: string): string => {
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${STORAGE_URL}/${bucket}/${cleanPath}`;
};

/**
 * Normalise une URL Supabase publique vers ASSETS_URL si possible.
 * Permet de remplacer progressivement les URLs hardcodées du landing.
 */
export const normalizePublicAssetUrl = (input: string): string => {
  const value = input.trim();

  // Ex: https://<project>.supabase.co/storage/v1/object/public/<bucket>/<path>
  const match = value.match(
    /^https:\/\/[^/]+\.supabase\.co\/storage\/v1\/object\/public\/(.+)$/i,
  );
  if (match?.[1]) return getAssetUrl(match[1]);

  // Ex: https://cdn.burok.app/storage/v1/object/public/<bucket>/<path>
  const matchCdn = value.match(/^https:\/\/cdn\.burok\.app\/storage\/v1\/object\/public\/(.+)$/i);
  if (matchCdn?.[1]) return getAssetUrl(matchCdn[1]);

  return value;
};

